import React from "react";

const PageLoader = () => {
  return (
    <div style={styles.loaderContainer}>
      <div style={styles.spinner}></div>
    </div>
  );
};

const styles = {
  loaderContainer: {
    height: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  spinner: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    border: "5px solid transparent",
    borderTop: "5px solid #168acb", // blue
    borderRight: "5px solid #0cb14b", // green
    animation: "spin 1s linear infinite",
  },
};

export default PageLoader;
